import { useEffect, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './AboutCare.css';
import DynamicBreadcrumb from '../../include/DynamicBreadcrumb';

import api from '../../../../api';

const API_URL = '/api/pages/about-us/about-care';

function AboutPage() {

    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  

    // 3. Fetch data using Axios
    useEffect(() => {
        const fetchPageData = async () => {
            try {
                // Assuming your API returns the JSON structure you provided
                const response = await api.get(API_URL);
                setPageData(response.data.groups);
                setLoading(false);
            } catch (err) {
                console.error("Error fetching data:", err);
                setError("Failed to load content.");
                setLoading(false);
            }
        };

        fetchPageData();
    }, []);

    // State for Read More functionality
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleReadMore = () => {
        setIsExpanded(!isExpanded);
    };

    // --- Helper Functions to extract data from the complex structure ---

    const getSectionData = (sectionName) => {
        if (!pageData) return null;
        const sectionGroup = pageData.find(group => group.hasOwnProperty(sectionName));
        return sectionGroup ? sectionGroup[sectionName] : null;
    };

    // Extract specific section data
    const bannerSection = getSectionData('banner_section');
    const aboutSection = getSectionData('about_section');
    const visionMissionSection = getSectionData('vision_mission_section');
    const facultySection = getSectionData('faculty_section');
    const tabSection = getSectionData('tab_section');

    // Dynamic slider helpers
    const getBannerSettings = (itemsLength) => ({
    dots: false,
    infinite: itemsLength > 1, // disable infinite when only one slide
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: itemsLength > 1, // disable autoplay if only one slide
    autoplaySpeed: 3000,
    });

    const getCoverflowSettings = (itemsLength) => ({
    dots: itemsLength > 1,
    infinite: itemsLength > 1,
    speed: 500,
    centerMode: itemsLength > 1,
    variableWidth: itemsLength > 1,
      infinite: itemsLength > 1,
     autoplay: itemsLength > 1,
    slidesToScroll: 1,
    });

   const getExecutiveSettings = (itemsLength) => ({
  dots: false,
  arrows: true,
  infinite: itemsLength > 1,
  speed: 500,
  autoplay: itemsLength > 1,
  autoplaySpeed: 3000,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 992, settings: { slidesToShow: 3 } },
    { breakpoint: 768, settings: { slidesToShow: 2 } },
    { breakpoint: 576, settings: { slidesToShow: 1 } },
  ],
});

const getFinanceSettings = (itemsLength) => ({
  dots: false,
  arrows: true, 
  infinite: itemsLength > 1,
  speed: 500,
  autoplay: itemsLength > 1,
  autoplaySpeed: 3000,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 992, settings: { slidesToShow: 3 } },
    { breakpoint: 768, settings: { slidesToShow: 2 } },
    { breakpoint: 576, settings: { slidesToShow: 1 } },
  ],
});

    // Handle loading and error states
    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const bannerCarousel = bannerSection?.banner_carousel || [];
    const aboutContent = aboutSection?.about_content || [];
    const secondaryContent = aboutSection?.secondary_content || [];
  const readMoreRaw = aboutSection?.readMore_about_content || {};
const readMoreContent = Object.values(readMoreRaw);
    const readMoreBtnText = aboutSection?.readMore_btn || 'READ MORE';
    const readLessBtnText = aboutSection?.readLess_btn || 'READ LESS';
    const logoImages = aboutSection?.logo_images || [];

    const visionTitle = visionMissionSection?.vision_title || 'VISION';
    const visionContent = visionMissionSection?.vision_content || 'Default Vision Content';
    const visionImage = visionMissionSection?.vis_image || '';
    const missionTitle = visionMissionSection?.mission_title || 'MISSION';
    const missionContent = visionMissionSection?.mission_content || 'Default Mission Content';
    const missionImage = visionMissionSection?.mis_image || '';

    const topManagementNames = facultySection?.faculty_name || [];
    const topManagementDesignations = facultySection?.faculty_designation || [];
    const topManagementImages = facultySection?.faculty_image || [];
    const topManagementData = topManagementNames.map((name, index) => ({
        name: name,
        role: topManagementDesignations[index] || '',
        src: topManagementImages[index] || ''
    }));

    const executiveTitles = tabSection?.executive_title || [];
    const executiveDesignations = tabSection?.executive_designation || [];
    const executiveImages = tabSection?.executive_image || [];
    const executiveData = executiveTitles.map((title, index) => ({
        name: title,
        designation: executiveDesignations[index] || '',
        src: executiveImages[index] || ''
    }));

    const financeTitles = tabSection?.finance_title || [];
    const financeDesignations = tabSection?.finance_designation || [];
    const financeImages = tabSection?.finance_image || [];
    const financeData = financeTitles.map((title, index) => ({
        name: title,
        designation: financeDesignations[index] || '',
        src: financeImages[index] || ''
    }));


    return (
        <>
        <div className="about-us-care-section">
            <section className="alumni_banner ">
                <section className="breadcrump_section">
                    {bannerCarousel.length > 1 ? (
                    <Slider {...getBannerSettings(bannerCarousel.length)} className="banner-slider">
                        {bannerCarousel.map((src, index) => (
                        <div key={index} className="banner-slider">
                            <img
                            src={
                                src.startsWith("http")
                                ? src
                                : `${process.env.REACT_APP_API_URL}/public/${src}`
                            }
                            alt={`Banner Image ${index + 1}`}
                            className="img-fluid"
                            />
                        </div>
                        ))}
                    </Slider>
                    ) : bannerCarousel.length === 1 ? (
                    <div className="banner-slider">
                        <img
                        src={
                            bannerCarousel[0].startsWith("http")
                            ? bannerCarousel[0]
                            : `${process.env.REACT_APP_API_URL}/public/${bannerCarousel[0]}`
                        }
                        alt="Banner"
                        className="img-fluid"
                        />
                    </div>
                    ) : null}
                    
                    <DynamicBreadcrumb />
                </section>
            </section>
            
            <section>
                <div className="about-care ">
                    <div className="container">
                        <div className="sec-title text-center">
                            <h2>ABOUT CARE</h2>
                        </div>
                        <div className="row d-flex justify-content-start align-items-start text-align-justify">
                            <div className="col-md-7" >
                                <div className="text">
                                    {aboutContent.map((paragraph, index) => (
                                        <p key={`about-p-${index}`}>{paragraph}</p>
                                    ))}
                                </div>
                            </div>
                            <div className="col-md-5" >
                                <div className="slick-coverflow-container">
                                    <Slider {...getCoverflowSettings(logoImages.length)}>
                                        {logoImages.map((item, index) => (
                                            <div key={index} style={{ width: 300, padding: '0 15px' }}>
                                                <div className="slick-coverflow-slide">
                                                    <img src={`${process.env.REACT_APP_API_URL}/public/${item.src}`} alt={item.alt || `Logo ${index + 1}`} />
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </div>
                        </div>

                        <div className="row ">
                            <div className="col-md-12" >
                                <div className="text">
                                    {secondaryContent.map((paragraph, index) => (
                                        <p key={`secondary-p-${index}`}>{paragraph}</p>
                                    ))}
                                </div>

                                {isExpanded && (
                                    <div id="moreText">
                                        <div className="text">
                                            {readMoreContent.map((paragraph, index) => (
                                                <p key={`read-more-p-${index}`}>{paragraph}</p>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {readMoreContent.length > 0 && (
                                    <button onClick={toggleReadMore} id="readMoreBtn" className="readmoreall mb-5">
                                        {isExpanded ? readLessBtnText : readMoreBtnText}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="vismis py-5 mb-5">
                <div className="container ">
                    <div className="row d-flex justify-content-center align-items-center vismis-inner text-white gap-5">
                        <div className="col-md-5 mb-4">
                            <div className="book1">
                                <div className="cover-title1 text-center d-block d-md-none mx-auto">
                                    <h2 className="vismis-title mt-3 text-white">
                                        {visionTitle.toUpperCase()}
                                    </h2>
                                </div>
                                <div className="cover d-none d-md-flex">
                                    <div className="vismis-img">
                                        <img src={`${process.env.REACT_APP_API_URL}/public/${visionImage}`} alt="Vision" />
                                    </div>
                                    <div className="cover-title text-center ">
                                        <h2 className="vismis-title mt-3 text-white">
                                            {visionTitle.toUpperCase()}
                                        </h2>
                                    </div>
                                </div>
                                <div className="vismis-content p-4 text-center">
                                    <p className="vismis-text">
                                        <span className="quotes_left">“</span>
                                        <strong>{visionContent}</strong>
                                        <span className="quotes_right">”</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-5 mb-4">
                            <div className="book2">
                                <div className="cover-title1 text-center d-block d-md-none mx-auto">
                                    <h2 className="vismis-title mt-3 text-white">
                                        {missionTitle.toUpperCase()}
                                    </h2>
                                </div>
                                <div className="cover d-none d-md-flex">
                                    <div className="vismis-img">
                                        <img src={`${process.env.REACT_APP_API_URL}/public/${missionImage}`} alt="Mission" />
                                    </div>
                                    <div className="cover-title text-center ">
                                        <h2 className="vismis-title mt-3 text-white">
                                            {missionTitle.toUpperCase()}
                                        </h2>
                                    </div>
                                </div>
                                <div className="vismis-content2 p-4 text-center">
                                    <p className="vismis-text">
                                        <span className="quotes_left">“</span>
                                        <strong>{missionContent}</strong>
                                        <span className="quotes_right">”</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid">
                    <div className="row leader ">
                        <h3 className="d-flex justify-content-center align-items-center fs-3 ">{facultySection?.faculty_title || 'LEADERSHIP'}</h3>
                    </div>
                    <div className="sec-title text-center">
                        <h2>{facultySection?.faculty_subtitle?.toUpperCase() || 'TOP MANAGEMENT'}</h2>
                    </div>
                </div>
            </section>

            <section className="top-management">
                <div className="container">
                    <div className="row justify-content-center d-flex align-items-center">
                        {/* Top Management Cards */}
                        {topManagementData.map((member, index) => (
                            <div className="col-12 col-md-4" key={`top-mgmt-${index}`}>
                                <div className="team-card">
                                    <div className="team-img">
                                        <img src={`${process.env.REACT_APP_API_URL}/public/${member.src}`} alt={member.name} />
                                    </div>
                                    <div className="team-content">
                                        <h4>{member.name}</h4>
                                        <p className="role">{member.role}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Executive & Finance Council - uses dynamic data */}
            {executiveData.length > 0 && financeData.length > 0 && (
            <section className="council p-2 p-md-5">
                <div className="container">
                    {executiveData.length > 0 && (
                    <div className="finance-section">
                        <div className="sec-title text-center">
                            <h2>{tabSection?.tab_title?.[0]?.toUpperCase() || 'EXECUTIVE COUNCIL'}</h2>
                        </div>
                        <Slider {...getExecutiveSettings(executiveData.length)}>
                            {executiveData.map((member, index) => (
                                <div className="item" key={`exec-member-${index}`}>
                                    <div className="instructor-card">
                                        <div className="instructor-card-wrapper">
                                            <div className="instructor-avatar">
                                                <img src={`${process.env.REACT_APP_API_URL}/public/${member.src}`} alt={member.name} />
                                            </div>
                                        </div>
                                        <h5 className="instructor-name">{member.name}</h5>
                                        <div style={{ borderBottom: '2px dashed rgb(181 181 181)', marginTop: '13px' }}></div>
                                        <p className="instructor-designation mb-0">{member.designation}</p>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                    )}

                    {financeData.length > 0 && (
                    <div className="finance-section">
                        <div className="sec-title text-center">
                            <h2>{tabSection?.tab_title?.[1]?.toUpperCase() || 'FINANCE COUNCIL'}</h2>
                        </div>
                        <Slider {...getFinanceSettings(financeData.length)}>
                            {financeData.map((member, index) => (
                                <div className="item" key={`finance-member-${index}`}>
                                    <div className="instructor-card">
                                        <div className="instructor-card-wrapper">
                                            <div className="instructor-avatar">
                                                <img src={`${process.env.REACT_APP_API_URL}/public/${member.src}`} alt={member.name} />
                                            </div>
                                        </div>
                                        <h5 className="instructor-name">{member.name}</h5>
                                        <div style={{ borderBottom: '2px dashed rgb(181 181 181)', marginTop: '13px' }}></div>
                                        <p className="instructor-designation mb-0">{member.designation}</p>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                    )}
                </div>
            </section>
            )}
        </div>
        </>
    );
}

export default AboutPage;